import React, { useState, useRef, useEffect } from 'react';
import {
  Space,
  Tag,
  Tooltip,
  Avatar,
  Input,
  Select,
  Checkbox,
  InputNumber,
  Button,
  Dropdown,
  Menu,
  Modal,
  DatePicker,
} from 'antd';
import { MoreOutlined, WarningOutlined, UserOutlined } from '@ant-design/icons';
import { BsPencilSquare } from 'react-icons/bs';
import { AiOutlineSearch } from 'react-icons/ai';
import dayjs from 'dayjs';
import UserAvatar from '../../../../components/userAvatar/index';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import TaskObject from '@atlaskit/object/task';
import { useDispatch, useSelector } from 'react-redux';
import { setStoryPoints } from 'store/actions';
import ChildWorkItemsIcon from '@atlaskit/icon/core/child-work-items';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

dayjs.extend(isSameOrBefore);

const { Option } = Select;
const { SubMenu } = Menu;
const { TextArea } = Input;
const { confirm } = Modal;

//const taskTypes = ['⛔ Bug', '🔰 Story', '✔️ Task'];

const BacklogItem = ({
  task,
  isSelected,
  onSelect,
  handleUpdateTaskFromSprint,
  projectId,
  sprint_id,
  onUpdateTask,
  onDelete,
  handleDeleteTask,
  handleMoveTask,
  sprintList,
  sprintBacklogList,
  sprints,
  epicOptions,
  statusOptions,
  assigneeOptions,
  labelOptions,
  handleUpdateLabel,
  handleTaskClick,
  selectedTask,
}) => {
 
  const [isHovered, setIsHovered] = useState(false);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editingField, setEditingField] = useState(null);

  const [title, setTitle] = useState(task.title);
  const [status, setStatus] = useState(task.status);
  const [epic, setEpic] = useState(task.epic);
  const [dueDate, setDueDate] = useState(task.dueDate);
  const [assignee, setAssignee] = useState(task.assignee || null);
  const [label, setLabel] = useState(task.label);
  // const [story_points, setPoints] = useState(task.story_points);
  const [description, setDescription] = useState(task.description || '');

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [localStoryPoints, setLocalStoryPoints] = useState(task.story_points);
  const [issueTypeId, setIssueTypeId] = useState(
    task.issue_type_id
  );

  const [issueDropdownVisible, setIssueDropdownVisible] =
    useState(false);


  const story_points = useSelector(
    (state) => state.Authentication?.storyPoints,
  );
 
  // {
  //   console.log({ story_points });
  // }

  useEffect(() => {
    setDueDate(task.dueDate);
    setEpic(task.epic);
    setStatus(task.status);
    setTitle(task.title);
    setLocalStoryPoints(task.story_points);
  }, [task]);

  const actionBtnRef = useRef(null);
  // const points = task.points;
  const dispatch = useDispatch();

  useEffect(() => {
    const handleScroll = () => {
      setDropdownVisible(false);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const taskAssignee = task.assignee;

  const safeUsername = (username) =>
    typeof username === 'string' && username.trim() !== '' ? username : '?';

  const handleTitleBlur = () => {
    setIsEditingTitle(false);
  };

  const callUpdateHandler = (payload) => {
    if (typeof handleUpdateTaskFromSprint === 'function') {
      handleUpdateTaskFromSprint(payload, sprint_id);
    } else if (typeof onUpdateTask === 'function') {
      onUpdateTask(payload);
    } else {
      console.warn('No valid task update function provided');
    }
  };

  useEffect(() => {
    setDescription(task.description || '');
  }, [task.description]);

  const handleBlur = () => setEditingField(null);

  const isOverdueOrToday = dueDate
    ? dayjs(dueDate, 'YYYY-MM-DD').isSameOrBefore(dayjs(), 'day')
    : false;

  const subtaskTotal = task?.subtasks_count?.total ?? 0;
  const subtaskDone = task?.subtasks_count?.done ?? 0;

  const showDeleteConfirm = (task) => {
    confirm({
      title: 'Are you sure you want to delete this task?',
      content: `Task: ${task.title}`,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDeleteTask(task);
      },
    });
  };

  const getMenuList = () => {
    if (task.sprint_id === null) {
      // Task is in backlog → show sprintBacklogList (no backlog option)
      return sprintBacklogList?.length ? sprintBacklogList : [];
    } else {
      // Task is in a sprint → show sprintList (with backlog option included)
      return sprintList?.length ? sprintList : [];
    }
  };

  const getStatusColors = (status = '') => {
    const s = String(status || '')
      .toUpperCase()
      .trim();

    switch (s) {
      case 'DONE':
        return { bg: '#45d44fff', color: 'black' };
      case 'TO DO':
      case 'TODO':
        return { bg: '#E6E6E6', color: 'black' };
      default:
        return { bg: '#55b0e8ff', color: 'black' };
    }
  };

  const taskMenu = (
    <Menu>
      <Menu.SubMenu key="move" title="Move Task">
        {getMenuList().length > 0 &&
          getMenuList().map((sprint) => (
            <Menu.Item
              key={sprint.value ?? 'backlog'}
              onClick={() => handleMoveTask(task, sprint.value)}
            >
              {sprint.label}
            </Menu.Item>
          ))}
      </Menu.SubMenu>

      <Menu.Item key="delete" onClick={() => showDeleteConfirm(task)}>
        Delete Task
      </Menu.Item>
    </Menu>
  );

  const assigneeMenu = (
    <Menu
      onClick={({ key }) => {
        const selectedAssignee = assigneeOptions.find(
          (a) => String(a.user_id) === String(key),
        );
        if (!selectedAssignee) return;

        setAssignee(selectedAssignee);

        callUpdateHandler({
          id: task.id,
          title,
          status: status?.status_name,
          epic_id: epic?.epic_id,
          story_points,
          //  assignee_id: assignee?.user_id,
          assignee: assignee,
          assignee_id: selectedAssignee.user_id,
          dueDate,
        });
      }}
    >
      {assigneeOptions &&
        assigneeOptions.map((a) => (
          <Menu.Item key={a.user_id}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <UserAvatar username={safeUsername(a.username)} size={24} />
              <span>{safeUsername(a.username)}</span>
            </div>
          </Menu.Item>
        ))}
    </Menu>
  );

  const addMenu = (
    <Menu
      items={[
        {
          key: 'opentab',
          label: 'Open link in new Tab',
          onClick: () => {
            const id = task.issue_id || task.id;

            const url = `/admin/taskBoard/${projectId}/taskDetails/${id}`;

            window.open(url, '_blank', 'noopener,noreferrer');
           
          },
        },
        {
          key: 'openwindow',
          label: 'Open link in new window',
          onClick: () => {
            const id = task.issue_id || task.id;
            const url = `/admin/taskBoard/${projectId}/taskDetails/${id}`;

            window.open(url, '_blank', 'width=1200,height=800');
          },
        },
        {
          key: 'incognito',
          label: 'Open link in incognito window',
          onClick: () => console.log('Whiteboard clicked'),
        },
        {
          key: 'copylink',
          label: 'Copy link to clipboard',
          onClick: async () => {
            const id = task.issue_id || task.id;

            const url = `${window.location.origin}/admin/taskBoard/${projectId}/taskDetails/${id}`;

            await navigator.clipboard.writeText(url);

            alert('Link copied to clipboard 👍');
          },
        },
      ]}
    />
  );


  useEffect(() => {
    setIssueTypeId(task.issue_type_id);
  }, [task.issue_type_id]);

  const ISSUE_TYPES = [
    { id: 1, label: 'Task', Icon: TaskObject },
    { id: 2, label: 'Story', Icon: StoryObject },
    { id: 3, label: 'Bug', Icon: BugObject },
  ];

  const ISSUE_TYPE_ICON_MAP = {
    1: TaskObject, // TASK
    2: StoryObject, // STORY
    3: BugObject, // BUG
  };

  const IssueIcon = ISSUE_TYPE_ICON_MAP[issueTypeId];

  return (
    <>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false);
          setIsEditingTitle(false);
        }}
        style={{
          padding: '10px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          borderBottom: '1px solid #f0f0f0',
          background: isSelected ? '#e6f7ff' : '#fff',
        }}
      >
        {/* Left Section */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            minWidth: 300,
            maxWidth: 700,
            flex: '1',
            overflow: 'hidden',
          }}
        >
          <Dropdown
            open={issueDropdownVisible}
            onOpenChange={setIssueDropdownVisible}
            trigger={['click']}
            menu={{
              items: ISSUE_TYPES.map(
                ({ id, label, Icon }) => ({
                  key: id,
                  label: (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <Icon width={18} />
                      <span>{label}</span>
                    </div>
                  ),
                })
              ),

              onClick: ({ key, domEvent }) => {
                domEvent.stopPropagation();

                const selectedId = Number(key);

                setIssueTypeId(selectedId);

                callUpdateHandler({
                  id: task.id,
                  title,
                  status: status?.status_name,
                  epic_id: epic?.epic_id,
                  story_points,
                  assignee_id:
                    assignee?.user_id ||
                    task.assignee_id,

                  dueDate,

                  // IMPORTANT
                  issue_type_id: selectedId,
                });

                setIssueDropdownVisible(false);
              },
            }}
            getPopupContainer={() => document.body}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <IssueIcon width={35} />
            </div>
          </Dropdown>

          {/* <Tag color={issueColor} style={{ cursor: 'pointer' }}>
            {task.issue_type}
          </Tag> */}

          <Dropdown overlay={addMenu} trigger={['click']}>
            <Tag color="green" cursor="pointer">
              {task.key}
            </Tag>
          </Dropdown>

          {isEditingTitle ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                flex: 1,
                maxWidth: 350,
              }}
            >
              <Input
                size="small"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                autoFocus
              />

              {/* Save */}
              <Tooltip title="Save">
                <CheckOutlined
                  style={{
                    color: '#52c41a',
                    cursor: 'pointer',
                    fontSize: 16,
                  }}
                  onClick={() => {
                    callUpdateHandler({
                      id: task.id,
                      title,
                      status: status?.status_name,
                      epic_id: epic?.epic_id,
                      story_points,
                      assignee_id: assignee?.user_id,
                      dueDate,
                    });
                    setIsEditingTitle(false);
                  }}
                />
              </Tooltip>

              {/* Cancel */}
              <Tooltip title="Cancel">
                <CloseOutlined
                  style={{
                    color: '#ff4d4f',
                    cursor: 'pointer',
                    fontSize: 16,
                  }}
                  onClick={() => {
                    setTitle(task.title); // reset
                    setIsEditingTitle(false);
                  }}
                />
              </Tooltip>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flex: 1,
                maxWidth: 900,
                overflow: 'hidden',
              }}
            >
              <Tooltip title={title}>
                <span
                  onClick={() => handleTaskClick && handleTaskClick(task)}
                  style={{
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                  }}
                >
                  {title}
                </span>
              </Tooltip>

              {isHovered && (
                <Tooltip title="Edit title">
                  <BsPencilSquare
                    onClick={() => setIsEditingTitle(true)}
                    style={{
                      cursor: 'pointer',
                      marginLeft: 6,
                      flexShrink: 0,
                      fontSize: 14,
                    }}
                  />
                </Tooltip>
              )}
            </div>
          )}
        </div>

        {/* Right Section */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            overflow: 'hidden',
            textOverflow: 'hidden',
          }}
        >
          {/* Epic */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
            }}
          >
            {/* Subtask Icon */}
            {subtaskTotal > 0 && (
              <Tooltip
                title={`${subtaskDone} of ${subtaskTotal} child work items complete`}
                placement="top"
                hasArrow
              >
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ChildWorkItemsIcon
                    style={{
                      fontSize: 14,
                      cursor: 'pointer',
                      color: 'gray',
                    }}
                    size="medium"
                  />
                </span>
              </Tooltip>
            )}

            {/* Epic (UNCHANGED WIDTH) */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: 80,
                justifyContent: 'center',
              }}
            >
              <Dropdown
                trigger={['click']}
                placement="bottomLeft"
                getPopupContainer={() => document.body}
                overlay={
                  <div
                    style={{
                      maxHeight: 300,
                      overflowY: 'auto',   // ✅ only scroll here
                    }}
                  >
                    <Menu
                      style={{
                        maxHeight: 'none',
                        overflow: 'visible',
                      }}
                      onClick={({ key }) => {
                        const selectedEpic = epicOptions.find(
                          (e) => e.epic_id === Number(key),
                        );
                        if (!selectedEpic) return;
                        setEpic(selectedEpic);
                        callUpdateHandler({
                          id: task.id,
                          title,
                          status: status?.status_name,
                          epic_id: selectedEpic.epic_id,
                          story_points,
                          assignee_id: assignee?.user_id,
                          dueDate,
                        });
                      }}
                      items={epicOptions.map((e) => ({
                        key: e.epic_id,
                        label: e.epic_name,
                      }))}
                    />
                  </div>
                }
              >
                <Tooltip title={epic?.epic_name || epic}>
                  <Tag
                    color="geekblue"
                    style={{
                      width: '100%',
                      textAlign: 'center',
                      cursor: 'pointer',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {epic?.epic_name || epic}
                  </Tag>
                </Tooltip>
              </Dropdown>
            </div>
          </div>

          {/* Status */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: 80,
              justifyContent: 'center',
            }}
          >
            <Dropdown
              trigger={['click']}
              overlay={
                <Menu
                  onClick={({ key }) => {
                    const selectedStatus = statusOptions.find(
                      (s) => String(s.id) === String(key),
                    );
                    if (!selectedStatus) return;

                    setStatus(selectedStatus);
                    callUpdateHandler({
                      id: task.id,
                      title,
                      status: selectedStatus.status_name,
                      epic_id: epic?.epic_id,
                      story_points,
                      assignee_id:
                        assignee?.user_id ||
                        task.assignee_id ||
                        task.assignee?.id,
                      assignee: assignee || task.assignee,
                      dueDate,
                    });
                  }}
                >
                  {statusOptions?.map((s) => {
                    const colors = getStatusColors(s.status_name);
                    return (
                      <Menu.Item
                        key={s.id}
                        style={{
                          backgroundColor: colors.bg,
                          color: colors.color,
                          fontWeight: 500,
                          borderRadius: 6,
                          margin: '4px 0',
                        }}
                      >
                        {s.status_name}
                      </Menu.Item>
                    );
                  })}
                </Menu>
              }
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <Tooltip
                title={status?.status_name || status || 'Select Status'}
                placement="top"
              >
                {(() => {
                  const colors = getStatusColors(status?.status_name || status);

                  return (
                    <Tag
                      style={{
                        width: '100%',
                        textAlign: 'center',
                        cursor: 'pointer',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        backgroundColor: colors.bg,
                        color: colors.color,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {status?.status_name || status || 'Select Status'}
                    </Tag>
                  );
                })()}
              </Tooltip>
            </Dropdown>
          </div>

          {/* Due Date */}
          <div style={{ width: 90 }}>
            {editingField ? (
              <DatePicker
                value={dueDate ? dayjs(dueDate, 'YYYY-MM-DD') : null}
                format="DD MMM"
                size="small"
                onChange={(date) => {
                  const newDate = date ? date.format('YYYY-MM-DD') : null;
                  setDueDate(newDate);

                  callUpdateHandler({
                    id: task.id,
                    title,
                    status: status?.status_name,
                    epic_id: epic?.epic_id,
                    story_points,
                    assignee_id: assignee?.user_id,
                    assignee: assignee,
                    dueDate: newDate,
                  });
                }}
                //getPopupContainer={(triggerNode) => triggerNode.parentNode}
                getPopupContainer={() => document.body}
                allowClear
                style={{ width: '100%' }}
              />
            ) : dueDate ? (
              <Tag
                icon={
                  dayjs(dueDate, 'YYYY-MM-DD').isSameOrBefore(
                    dayjs(),
                    'day',
                  ) ? (
                    <WarningOutlined />
                  ) : null
                }
                color={
                  dayjs(dueDate, 'YYYY-MM-DD').isSameOrBefore(dayjs(), 'day')
                    ? 'red'
                    : 'default'
                }
                style={{
                  width: '100%',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => setEditingField(true)}
              >
                {dayjs(dueDate, 'YYYY-MM-DD').format('DD MMM')}
              </Tag>
            ) : (
              <Tag
                color="default"
                style={{
                  width: '100%',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => setEditingField(true)}
              >
                -
              </Tag>
            )}
          </div>

          {/* Points */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: 80,
              justifyContent: 'center',
            }}
          >
            {editingField === 'story_points' ? (
              <InputNumber
                size="small"
                min={0}
                value={localStoryPoints}
                onChange={(value) => {
                  setLocalStoryPoints(value);
                }}

                onBlur={() => {
                  // dispatch(setStoryPoints(story_points));
                  setEditingField(null);
                  callUpdateHandler({
                    id: task.id,
                    title,
                    status: status?.status_name || task.status,
                    epic_id: epic?.epic_id || task.epic_id,
                    story_points: localStoryPoints,

                    assignee_id:
                      assignee?.user_id ||
                      task.assignee_id ||
                      task.assignee?.id,
                    assignee: assignee || task.assignee,
                    dueDate,
                  });
                }}
                autoFocus
                style={{ width: '100%' }}
              />
            ) : (
              <Tag
                style={{
                  width: '100%',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingField('story_points');
                }}
              >
                {localStoryPoints}

              </Tag>
            )}
          </div>

          {/* Assignee */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Dropdown
              trigger={['click']}
              getPopupContainer={() => document.body}
              overlay={
                <div
                  style={{
                    minHeight: 120,
                    maxHeight: 250,
                    overflowY: 'auto', 
                  }}
                >
                  {assigneeMenu}
                </div>
              }
            >
              <div onClick={(e) => e.stopPropagation()}>
                <Tooltip title={safeUsername(assignee?.username)}>
                  <UserAvatar
                    username={safeUsername(assignee?.username)}
                    size={32}
                    className="clickable-avatar"
                  />
                </Tooltip>
              </div>
            </Dropdown>
          </div>

          {/* Actions */}
          <div style={{ width: 36 }}>
            <Dropdown
              overlay={taskMenu}
              trigger={['click']}
              visible={dropdownVisible}
              onVisibleChange={setDropdownVisible}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <Button icon={<MoreOutlined />} ref={actionBtnRef} />
            </Dropdown>
          </div>
        </div>
      </div>
    </>
  );
};

export default BacklogItem;
